<template>
  <div :class="(showErrorEvenIfParamIsNotDirty ? error : (error && form[paramName].$dirty)) ? 'custom-field--invalid' : 'custom-field--valid'">
    <label class="custom-label" :for="id" :class="[brandClass,{'_profileStyle': profileStyle},{hide:hideErrors}]">
      {{ label }}
    </label>
    <div style="position: relative" class="custom-div-input-field" :class="brandClass">
      <input class="custom-input-field " 
        :class="[brandClass, {'disabled':disabled}, {'_profileStyle':profileStyle},{hide:hideErrors}]" 
        :type="type" 
        :autocomplete="autocomplete || true" 
        :inputmode="inputmode"
        :name="paramName" 
        :id="id" 
        :disabled="disabled"
        :readonly="readonly"
        :placeholder="placeholder"
        :value="modelValue" 
        :passwordrules="passwordrules"
        @input="onInput" 
        @change="onChange" 
        @blur="onBlur" 
        @focus="onFocus"
        @keydown="onKeydown"
        @keyup="onKeyup"/>
        <div
          class="custom-input-icon custom-input-icon-valid" :class="brandClass" 
          v-if="showCheckMark && !showToggle && validAndDirty && !profileStyle">
        </div>
        <div
          class="custom-input-icon custom-input-icon-error" :class="brandClass" 
          v-if="invalid && !profileStyle"
        >
          <div class="error-icon" :class="brandClass">!</div>
        </div>
        <div
          v-if="showToggle && (!invalid || profileStyle)"
          tabindex="0"
          role="button" 
          :aria-pressed="type && type=='text'"
          :aria-label="'show or hide password'"
          v-on:click="$emit('toggleClick')"
          class='toggle'
          @keydown="ariaClick"
          :class="[{showPassword:type && type=='text'},brandClass,{'_profileStyle': profileStyle}]"
        ></div>
        <div class="additionalMessage" :class="brandClass">
          {{ additionalMessage }}
        </div>
        <div class="custom-error" :class="[brandClass, {hide:hideErrors}]" v-if="(showErrorEvenIfParamIsNotDirty ? error : (error && form[paramName].$dirty))">{{error.message}}</div>
    </div>
  </div>
</template>

<script>
import oneUtils from "../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

export default {
  name: 'OneInput',
  mixins:[oneUtils.accessibilityMixin],
  emits: ['update:modelValue','change','blur', 'keydown', 'keyup', 'toggleClick', 'focus', 'input'],
  props: {
    brandClass:{
      type: String,
      required: false,
      default: '__b'
    },
    hideErrors:{
      type: Boolean,
      required: false,
      default: false
    },
    profileStyle:{
      type: Boolean,
      required: false,
      default: false
    },
    showToggle:{
      type: Boolean,
      required: false,
      default: false
    },
    showCheckMark:{
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    additionalMessage: {
      type: String,
      required: false,
      default: null
    },
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    autocomplete: {
      type: String,
      required: false,
      default: null
    },
    inputmode: {
      type: String,
      required: false,
      default: "text"
    },
    passwordrules: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false,
    },
    modelValue: null,
    form:{
      type: Object,
      required: false
    },
    errors:null,
    paramName:{
      type: String,
      required: true
    },
    showErrorEvenIfParamIsNotDirty: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  /* Can add validation here
  watch: {
    value: {
      handler(newValue, oldValue) {

      },
    },
  }, */
  computed: {
    error(){
      return this.errors.find(e=>e.thereIsTheError);
    },
    invalid(){
      return this.error && this.form[this.paramName].$dirty
    },
    validAndDirty(){
      return this.form[this.paramName].$dirty && !this.invalid;
    }
  },
  methods: {
    onInput(event) {
      // Can add validation here
      this.$emit('update:modelValue', event.target.value);
      this.$emit('input', event.target.value);
    },
    onChange(event) {
      // Can add validation here
      this.$emit('change', event.target.value);
    },
    onBlur(event) {
      // Can add validation here
      this.$emit('blur', event.target.value);
    },
    onFocus(event) {
      // Can add validation here
      this.$emit('focus', event.target.value);
    },
    onKeydown(event) {
      // Can add validation here
      this.$emit('keydown', event.target.value, event);
    },
    onKeyup(event) {
      // Can add validation here
      this.$emit('keyup', event.target.value);
    },
  },
}
</script>

<style lang="scss" scoped>
@import './styles/_fonts.scss';
@import './styles/_variables.scss';



  .custom-label{
    font-size: 14px;
    &.__rr {
      color: $grey;
      text-transform: uppercase;
      font-family: RivieraNights-Bold;
    }
    &.__m{
      color: black;
      font-family: MINISansSerif;
    }
    &.__motorrad{
    }
    // &.__motorrad{
    //   position: absolute;
    //   z-index: 2;
    //   top: 15px;
    //   left: 20px;
    //   text-transform: uppercase;
    //   color: $motorradgrey;
    //   font-size: 16px;
    //   font-weight: 400;
    // }
    &._profileStyle{
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
      color: $grey5;
      margin-bottom: 8px;
      display: block;
      &.__m{
        color: black;
      }
      &.__t{
        color: black;
      }
    }
    &.__t{
      font-family: ToyotaSemibold;
    }
    &.__alphabet{
      color: $grey10;
    }
  }

  .custom-div-input-field {
    &.__rr {
      margin-top: 8px;
    }
  }
  .custom-input-field{
    position: relative;
    font-family: inherit;
    border: 1px solid $grey;
    width: 100%;
    line-height: 1em;
    padding: 11px;
    padding-right: 45px;
    min-width: 0;
    color: $black;
    font-size: 16px;
    height: 48px;
    &:focus {
      outline: none;
      border: 2px solid black;
    }
    &:disabled {
      color: rgba($black, 0.6);
    }
    &.__rr{
      font-weight: 300;
      font-family: RivieraNights-Light;

      &.disabled {
        color: $rrlightgrey;
        background-color: transparent !important;
      }

    }
    &.__motorrad{
      border-color: black;
      margin-top: 5px;
      font-weight: bold;
    }
    &.__m {
      border: 1px solid black;
      font-family: MINISansSerif;
      color: black;
      font-weight: 300; 
      font-size: 18px;
      &:focus {
        outline: none;
        border: 2px solid black;
      }
      &:disabled {
        color: rgba(black, 0.6);
      }
    }
    &.__t{
      color: black;
      font-family: ToyotaSemibold;
      border: 1px solid $toyotainputborder;
      font-size: 15px;
      &:focus {
        outline: none;
        border: 2px solid black;
      }
      &:disabled {
        color: rgba(black, 0.6);
      }
    }
    &.__alphabet{
      color: $grey10;
      border-color: $alphabetgrey;
      &:focus{
        border: 2px solid $alphabetfreshblue;
      }
      &:disabled {
        color: rgba($grey10, 0.6);
      }
    }
    &.__d{
      box-shadow: 0 0 0 30px transparent !important;
      -webkit-box-shadow: 0 0 0 30px transparent !important;
      -webkit-text-fill-color: #fff!important;
      background: transparent;
      color: white !important;
      border: 1px solid white;
      &:focus {
        outline: none;
        border: 2px solid white;
      }
    }
    &:disabled{
      background-color: $grey6;
      &.__d{
        background-color: rgba($grey6, 0.6);
      }
    }
    &._profileStyle{
      height: 52px;
    }
  }
  
  .custom-field--invalid{
      
      
    .custom-error{
      color: $red;
      font-size: 12px;
      line-height: 14px;
      margin-top: 5px;

      &.__rr {
        color: white;
        font-family: RivieraNights-Regular;
        margin-top: 10px;
      }

      &.__motorrad{
        color: $motorraderror;
      }
      
      &.__d{
        color: $darkmodeRed;
      }
    }
    .custom-label{
      color: black;
      &.__t{
        color: $toyotared;
      }
      &.__rr{
        color: $grey2;
      }
    }
    .custom-input-field{
      // color: $errorred;
      background-color: $errorbg;
      &:-internal-autofill-selected{
        background-color: $errorbg !important;
      }
      &:-webkit-autofill{
        -webkit-box-shadow: 0 0 0 30px $errorbg inset !important;
      }
      border: 2px solid $errorred;
      &:focus {
        outline: none;
        border: 2px solid black;
      }
      &.__rr {
        border: 2px solid $rrred;
        color: $rrcustominputfielderror;
        font-family: RivieraNights-Light;
      }
      &.__t{
        font-family: Arial, Helvetica, sans-serif;
        color: $toyotared;
        border: 2px solid $toyotared;
        &:focus {
          outline: none;
          border: 2px solid black;
        }
      }
      &.__m{
        &__d{
          background-color: transparent;
           &:-internal-autofill-selected{
            background-color: transparent !important;
          }
          &:-webkit-autofill{
            -webkit-box-shadow: 0 0 0 30px transparent inset !important;
          }
          border: 2px solid $darkmodeRed;
          color: white;
        }
      }
      &.__motorrad{
        background: $motorradred;
        &:-internal-autofill-selected{
          background-color: $motorradred !important;
        }
        &:-webkit-autofill{
          -webkit-box-shadow: 0 0 0 30px $motorradred inset !important;
        }
        border-color: 2px solid $motorradred;
        &:focus{
          border: 2px solid;
        }
      }
      &.__d{
        background-color: transparent ;
        &:-internal-autofill-selected{
          background-color: transparent !important;
        }
        &:-webkit-autofill{
          -webkit-box-shadow: 0 0 0 30px transparent inset !important;
        }
        border: 2px solid $darkmodeRed;
        color: white;
        &:focus {
          outline: none;
          border: 2px solid white;
        }
      }
      &.__alphabet{
        &:focus{
          border: 2px solid $alphabetfreshblue;
        }
      }
    }
  }

  .custom-input-icon {
    position: absolute;
    
  }
  .custom-input-icon-valid {
    right: 15px;
    top: 20px;
    width: 13px;
    height: 10px;
    background-image: url('@/assets/default/light/check-default-light.svg');
   
    &.__alphabet{
      background-image: url('@/assets/alphabet/light/check-alphabet-light.svg');
    }
    &.__m{
      background-image: url('@/assets/mini/light/check-mini-light.svg');
    }
    &.__rr {
      background-image: url('@/assets/rr/light/check-rr-light.svg');
    }
    &.__motorrad {
      background-size: 100%;
      top: 23px;
      right: 18px;
      background-image: url('@/assets/motorrad/light/check-motorrad-light.svg');
    }
    &.__d{
      background-image: url('@/assets/default/dark/check-default-dark.svg');     
    }
  }
  .custom-input-icon-error {
    font-size: 16px;
    font-weight: 400;
    right: 20px;
    color: $red;
    top: 14px;
    &.__rr{
      background-image: url('@/assets/rr/light/input-error-rr-light.svg');
      right: 15px;
      top: 15px;
      position: absolute;
      display: flex;
      justify-content: center;
      height: 24px;
      width: 24px;
      background-repeat: no-repeat;
      background-position-x: center;
    }
    &.__motorrad{
      background-image: url('@/assets/motorrad/light/input-error-motorrad-light.svg');
      right: 15px;
      top: 18px;
      position: absolute;
      display: flex;
      justify-content: center;
      height: 24px;
      width: 24px;
      background-repeat: no-repeat;
      background-position-x: center;
    }
    &.__alphabet{
      background-image: url('@/assets/alphabet/light/input-error-alphabet-light.svg');
      right: 15px;
      top: 15px;
      position: absolute;
      display: flex;
      justify-content: center;
      height: 24px;
      width: 24px;
      background-repeat: no-repeat;
      background-position-x: center;
    }
  }
  .error-icon {
    &.__rr {
      display: none;
    }
    &.__motorrad {
      display: none;
    }
    &.__alphabet {
      display: none;
    }
  }
  .toggle {
    &:hover{
      outline: auto;
    }
    cursor: pointer;
    right: 15px;
    top: 12px;
    position: absolute;
    display: flex;
    justify-content: center;
    height: 24px;
    width: 24px;
    &._profileStyle{
      top: 14px;
    }
    background-image: url('@/assets/default/light/show-password-default-light.svg');
    &.showPassword{
      background-image: url('@/assets/default/light/hide-password-default-light.svg');
    }
    &.__d{
      background-image: url('@/assets/default/dark/show-password-default-dark.svg');
      &.showPassword{
        background-image: url('@/assets/default/dark/hide-password-default-dark.svg');
      }
    }
    &.__m{
      background-image: url('@/assets/mini/light/show-password-mini-light.svg');
      &.showPassword{
        background-image: url('@/assets/mini/light/hide-password-mini-light.svg');
      }
      &.__d{
        background-image: url('@/assets/mini/dark/show-password-mini-dark.svg');
        &.showPassword{
          background-image: url('@/assets/mini/dark/hide-password-mini-dark.svg');
        }
      }
    }
    &.__motorrad{
      right: 15px;
      top: 17px;
      background-size: 100%;
      background-image: url('@/assets/motorrad/light/show-password-motorrad-light.svg');
      &.showPassword{
        background-image: url('@/assets/motorrad/light/hide-password-motorrad-light.svg');
      }
      &.__d{
        background-image: url('@/assets/mini/dark/show-password-mini-dark.svg');
        &.showPassword{
          background-image: url('@/assets/mini/dark/hide-password-mini-dark.svg');
        }
      }
    }
  }
  .additionalMessage{
    font-weight: 300;
    color: $grey5;
    margin-top: 5px;
    font-size: 12px;
    &.__d{
      color: white;
    }
    &.__rr {
        color: white;
        font-family: RivieraNights-Regular;
    }
  }
  .hide{
    &.custom-error, &.custom-label{
      color: transparent !important;
      -webkit-touch-callout: none; 
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
    &.custom-input-field{
      border-left: 0px solid;
    }
  }
</style>


